import { NgModule } from '@angular/core';
import { SearchModule } from './search.module';

@NgModule({
  imports: [SearchModule],
  exports: [SearchModule]
})
export class SharedUiSearchModule {}
